import React, { useState } from "react";
import AdminCateEditModal from "./AdminCateEditModal";
import ActiveFormModal from "./ActiveFormModal";
import defaultPic from "../assets/img/dummy.jpeg";
import AdminGeneralEditModal from "./AdminGeneralEditModal";
import { useDispatch } from "react-redux";
import { getAllCities, updateCityById } from "../actions/cityActions";

const AdminCitiesListRow = ({ current, i }) => {
  const [showActiveModal, setshowActiveModal] = useState(false);
  const openActiveModal = () => {
    setshowActiveModal((showActiveModal) => !showActiveModal);
  };
  const [showEditModal, setshowEditModal] = useState(false);
  const openEditModal = () => {
    setshowEditModal((showEditModal) => !showEditModal);
  };
  const dispatch = useDispatch();
  // const [values, setValues] = useState({
  //   _id: "",
  //   status: "",
  // });
  const handleSubmit = async (event) => {
    console.log("handleSubmit modal k bhr");

    event.preventDefault();
    const updatedStatus = !current.status; // Toggle the boolean value
    const statusData = {
      _id: current.id,
      status: updatedStatus, // Assign the toggled value
    };
    dispatch(updateCityById(statusData));

    setTimeout(() => {
      dispatch(getAllCities());
    }, 1000);
    setshowActiveModal(false);
  };
  console.log(current, "currenttttttt modal k bhr");
  return (
    <>
      <tr>
        <td>{i + 1}</td>
        <td>{current.name}</td>
        <td>
          <a
            href="#"
            className={`btn btn-sm ${
              current.status ? "btn-success" : "btn-dark"
            }`}
            onClick={() => setshowActiveModal(true)}
          >
            {current.status ? "Active" : "Deactivated"}
          </a>
          {/* {current.status === true ? (
            <a
              href="#"
              className="btn btn-sm btn-success"
              onClick={openActiveModal}
            >
              Active
            </a>
          ) : (
            <a
              href="#"
              className="btn btn-sm btn-dark"
              onClick={openActiveModal}
            >
              Deactivated
            </a>
          )} */}

          <a
            href="#"
            className="btn btn-sm btn-primary mx-1"
            onClick={openEditModal}
          >
            Edit
          </a>
          <a href="#" className="btn btn-sm btn-danger">
            Delete
          </a>
        </td>
      </tr>
      <ActiveFormModal
        openActiveModal={openActiveModal}
        showActiveModal={showActiveModal}
        current={current}
        handleSubmit={handleSubmit}
      />
      <AdminGeneralEditModal
        openEditModal={openEditModal}
        showEditModal={showEditModal}
        current={current}
      />
    </>
  );
};

export default AdminCitiesListRow;
